module.exports = __webpack_public_path__ + "static/img/circle_with_tk_in_middle1.8f1d2ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle_with_tk_in_middle1.png
// module id = TdjV
// module chunks = 0